<script>
import Layout from '@layouts/main'
import LoanDetails from '@/src/components/HMDA/LoanDetails.vue'
import Sticky from 'vue-sticky-directive'
import { hmdaMethods, broadcastGetters } from '@state/helpers'
import { hmdaACL } from '@/src/utils/accesslevels'
export default {
  directives: { Sticky },
  components: { Layout, LoanDetails },
  data() {
    return {
      showSpinner: true,
      showErrorsOnly: false,
      loanHeader: {},
      loanDetails: {},
      headerTitle: 'Loan details',
      breadcrumbs: [
        {
          text: 'Home',
          to: { path: '/home' },
        },
        {
          text: 'HMDA',
          to: { path: '/hmda' },
        },
        {
          text: 'Projects',
          to: { name: 'hmda-view-projects' },
        },
        {
          text: 'Project Summary',
          to: {
            name: 'hmda-project-details',
            params: { id: this.$route.params.projectId },
          },
        },
        { text: 'Loan Details', active: true },
      ],
      loanQuery: {},
      disablePrevBtn: false,
      disableNextBtn: false,
      isNextPrevReq: false,
    }
  },
  computed: {
    ...broadcastGetters,
    PROJECT_ID() {
      return this.$route.params.projectId || '0'
    },
    LAR_ID() {
      return this.$route.params.loanId || '0'
    },
  },
  watch: {
    messageTypeRuleEngine(m) {
      if (Number(m.RuleEngineStatus.ProjectId) === Number(this.PROJECT_ID)) {
        this.isNextPrevReq = true
        this.getLoanQuery()
        this.fetchLoan(this.loanQuery)
      }
    },
  },
  mounted() {
    hmdaACL.initializeAccessControls()
    if (!hmdaACL.isHMDAUser()) {
      return this.$router.push({
        name: 'home',
      })
    }
    this.getLoanQuery()
    this.fetchLoan(this.loanQuery)
  },
  methods: {
    ...hmdaMethods,
    wp(d) {
      return d || '--'
    },
    async fetchLoan(query) {
      this.showSpinner = true
      this.fetchLoanHeader(query.LoanId).then((h) => {
        this.loanHeader = h || {}
        this.showErrorsOnly = this.loanHeader.errorCount > 0
      })
      this.fetchLoanDetail({
        loanQuery: query,
        isNextPrevReq: this.isNextPrevReq,
      })
        .then((r) => {
          this.loanDetails = r.data || {}
          this.disableNextBtn =
            r.data.nextLoanNumber === 0 ||
            r.data.nextLoanNumber === null ||
            r.data.nextLoanNumber === undefined
          this.disablePrevBtn =
            r.data.previousLoanNumber === 0 ||
            r.data.previousLoanNumber === null ||
            r.data.previousLoanNumber === undefined
        })
        .finally(() => {
          this.showSpinner = false
          this.isNextPrevReq = false
        })
    },

    getLoanQuery() {
      this.loanQuery = JSON.parse(localStorage.getItem('loanQuery'))
    },

    prevLoan() {
      this.getLoanQuery()
      this.loanQuery.LoanId = this.loanQuery.previousLoanNumber
      this.fetchLoan(this.loanQuery)
    },

    nextLoan() {
      this.getLoanQuery()
      this.loanQuery.LoanId = this.loanQuery.nextLoanNumber
      this.fetchLoan(this.loanQuery)
    },

    checkUnsavedLoanData(urlName, urlParam) {
      const routeObj = {
        name: urlName,
        params: urlParam || {},
      }
      this.$refs.loanDetails.goToProjectSummary(routeObj)
    },
  },
}
</script>

<template>
  <Layout>
    <BaseSpinner v-if="showSpinner" />
    <div class="body--wrapper mt-1 m-auto container py-3 px-0">
      <b-breadcrumb class="mb-0 bg-transparent py-1 pl-0 ml-0">
        <b-breadcrumb-item @click="checkUnsavedLoanData('home')">
          <BaseIcon name="home"></BaseIcon>
        </b-breadcrumb-item>
        <b-breadcrumb-item @click="checkUnsavedLoanData('hmda')">
          HMDA
        </b-breadcrumb-item>
        <b-breadcrumb-item @click="checkUnsavedLoanData('hmda-view-projects')">
          Projects
        </b-breadcrumb-item>
        <b-breadcrumb-item
          @click="
            checkUnsavedLoanData('hmda-project-details', { id: PROJECT_ID })
          "
        >
          Project Summary
        </b-breadcrumb-item>
        <b-breadcrumb-item active>Loan Details</b-breadcrumb-item>
      </b-breadcrumb>
    </div>
    <div class="body--wrapper mt-1  bg-white container">
      <nav v-sticky sticky-offset="{top: 0}" sticky-z-index="20" class="mb-3">
        <div class="sticky-info alt">
          <table class="w-100">
            <tr>
              <td>
                <span class="muted">Loan Number</span>
                <b> {{ wp(loanHeader.loanNumber) }}</b>
              </td>
              <td>
                <span class="muted">Application Date</span>
                <b> {{ wp(loanHeader.applicationDate) }}</b>
              </td>
              <td>
                <span class="muted">Action Taken</span>
                <b> {{ wp(loanHeader.actionTaken) }}</b>
              </td>
              <td>
                <span class="muted">Action Taken Date</span>
                <b> {{ wp(loanHeader.actionTakenDate) }}</b>
              </td>
              <td>
                <span class="muted">Loan Purpose</span>
                <b> {{ wp(loanHeader.loanPurpose) }}</b>
              </td>
              <td>
                <span class="muted">Rule Status</span>
                <b> {{ wp(loanHeader.ruleStatus) }}</b>
              </td>
              <td>
                <span class="muted">Last Run Time</span>
                <b> {{ wp(loanHeader.lastRunTime) }}</b>
              </td>
              <td>
                <span class="muted">Error Count</span>
                <b> {{ wp(loanHeader.errorCount) }}</b>
              </td>
            </tr>
          </table>
        </div>

        <b-row
          v-if="loanHeader.errorCount > 0"
          class="pt-2 border-bottom pb-3 bg-filter"
        >
          <b-col cols="12">
            <BaseELabel label="Filter" class="d-inline-block" /> :
            <b-form-checkbox
              v-model="showErrorsOnly"
              switch
              class="d-inline-block ml-3"
              >Show Errors Only</b-form-checkbox
            >
          </b-col>
        </b-row>
      </nav>
      <LoanDetails
        ref="loanDetails"
        :filter="{ showErrorsOnly }"
        :loan="loanDetails"
        :summary="loanHeader"
        class="mt-5"
        :disable-prev-btn="disablePrevBtn"
        :disable-next-btn="disableNextBtn"
        @prevLoan="prevLoan"
        @nextLoan="nextLoan"
      />
    </div>
  </Layout>
</template>
<style scoped>
.bg-filter {
  background-color: #fff;
  /* background-color: #1e3866; */
  /* color:#fff; */
}
.sticky-info .muted {
  display: block;
  color: #aecbd0;
}
.sticky-info {
  padding: 8px;
  background: #4b868f;
  color: #fff;
  border-bottom: 4px solid #4b868f;
  /* box-shadow: 2px 5px #425f63; */
  /* 3px solid #4b868f */
}
.sticky-info.alt {
  background: #fff;
  color: rgb(65, 64, 64);
  /* box-shadow: 2px 5px #c8cbcb; */
}
.sticky-info.alt .muted {
  color: #bdbaba;
  padding-bottom: 0.2rem;
}
</style>
